// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PAkz","left":"styles_left__1mSWi","desktopActions":"styles_desktopActions__19oO4","title":"styles_title__InPj5"};